export const externalGameTypesSelector = (state) => state.externalGameTypes;
